import axios from "axios";
import createAuthFlowProcess from "./createAuthFlowProcess";
import authFlowInterceptorFactory from "./authFlowInterceptorFactory";
import httpRetryInterceptorErrorHandler from "./httpRetryInterceptorErrorHandler";
import axiosConfig from "./axiosConfig";

const axiosInstance = axios.create(axiosConfig);

axiosInstance.interceptors.response.use(
  (response) => response,
  httpRetryInterceptorErrorHandler
);

export default authFlowInterceptorFactory(axiosInstance, createAuthFlowProcess);
